<template>
  <div class="radio">
    <div
      class="radio-item"
      :class="{ 'active-item-ra': permission === 0 }"
      @click="changePermission(0)"
    >
      <img
        src="@/assets/clock/com_icon_choice1.png"
        alt=""
        class="radio-icon"
        v-show="permission === 0"
      />
      <img
        src="@/assets/clock/com_icon_choice_de.png"
        alt=""
        class="radio-icon"
        v-show="permission === 1"
      />
      所有人可见
    </div>
    <div
      class="radio-item"
      :class="{ 'active-item-ra': permission === 1 }"
      @click="changePermission(1)"
    >
      <img
        src="@/assets/clock/com_icon_choice1.png"
        alt=""
        class="radio-icon"
        v-show="permission === 1"
      />
      <img
        src="@/assets/clock/com_icon_choice_de.png"
        alt=""
        class="radio-icon"
        v-show="permission === 0"
      />
      仅管理员可见
    </div>
  </div>
</template>

<script>
export default {
  props: {
    permission: {
      type: Number,
      default: 0
    }
  },
  methods: {
    changePermission(value) {
      this.$emit('update:permission', value);
    }
  }
};
</script>

<style lang="stylus" scoped>
.radio {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .radio-item {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 27px;
    font-size: 12px;
    color: #dadada;
  }

  .radio-icon {
    margin-right: 3px;
    width: 13px;
    height: 12px;
    border: none;
  }

  .active-item-ra {
    color: #FF9645;
  }
}
</style>
